import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Table, ListGroup, ListGroupItem } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaEdit, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
import uuid from 'react-uuid';
import './Cropping.css';
import CroppingChildItemView from './CroppingChildItemView';
const CropAreaItemView = ({ cropping,toggleItemState, handleItemTogole, toggleChildItemState, handleChildItemToggle, handleHideChildrenCheck,hideChildren,cropAreaItem, cropAreaRecordItems, handleItemEditPopup, handleCropRecordPopupOpen, handleCropRecordPopupEdit, handleItemHighlight }) => {
    const [isOpen, setIsOpen] = useState(cropAreaItem.itemId == toggleItemState.itemId ? toggleItemState.isOpen : false);
    const [isIconUp, setIsIconUp] = useState(cropAreaItem.itemId == toggleItemState.itemId ? toggleItemState.isIconUp : false);
    const handleItemExpandCollapse = (itemId) => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTogole(itemId, !isOpen, !isIconUp)
    };
    if (cropAreaItem != undefined && cropAreaItem.isConnectedToAnotherCropAreaItem == false) {
        return (
            <Row>
                <Col>
                    <Card className="my-3">
                        <CardHeader className="item-header item_click" onClick={(itemId) => handleItemExpandCollapse(cropAreaItem.itemId)}>
                            <Row>
                                <Col sm="1">
                                    <a onMouseOver={(itemId) => handleItemHighlight(cropAreaItem.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                        {cropAreaItem.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={cropAreaItem.colour}></FaMapMarkerAlt> :
                                            cropAreaItem.mapMarkerType == 'polyline' ? <FaSlash color={cropAreaItem.colour}></FaSlash> :
                                                cropAreaItem.mapMarkerType == 'polygon' ? <FaDrawPolygon color={cropAreaItem.colour}></FaDrawPolygon> :
                                                    cropAreaItem.mapMarkerType == 'circle' ? <FaRegCircle color={cropAreaItem.colour}></FaRegCircle> :
                                                        cropAreaItem.mapMarkerType == 'rectangle' && <FaRegSquare color={cropAreaItem.colour}></FaRegSquare>}
                                    </a>
                                </Col>
                                <Col sm="5"><h6 className="text-uppercase">{cropAreaItem.name}</h6></Col>
                                <Col sm="5" className="text-end">
                                    <Button style={{ marginRight: "20px" }} color="primary" size="sm" onClick={(itemId) => handleItemEditPopup(cropAreaItem.itemId)}>
                                        Edit
                                    </Button>
                                    <Button style={{ marginRight: "20px" }} color="warning" size="sm" onClick={(itemId) => handleCropRecordPopupOpen(cropAreaItem.itemId)}>
                                        Add Crop Record
                                    </Button>
                                </Col>
                                <Col sm="1" className="text-end toggleoutline">
                                    {
                                        isIconUp ?
                                            <FaChevronUp /> :
                                            <FaChevronDown />
                                    }
                                </Col>
                            </Row>

                        </CardHeader>
                        <Collapse isOpen={isOpen}>
                            <CardBody>
                                <Row className="my-3">
                                    <Col>
                                        <Table bordered>
                                            <thead style={{ textAlign: "center" }}>
                                                <tr key={uuid()}>
                                                    <th style={{ width: "5%" }}> Edit </th>
                                                    <th style={{ width: "5%" }}> Year </th>
                                                    <th style={{ width: "10%" }}> Crop</th>
                                                    <th style={{ width: "10%" }}> Crop Yield (TDM/ ha) </th>
                                                    <th style={{ width: "20%" }}> Month Sown </th>
                                                    <th style={{ width: "20%" }}> Month Harvested </th>
                                                    <th style={{ width: "10%" }}> Cultivation Method</th>
                                                    <th style={{ width: "20%", textAlign: "left" }}> Mitigations in place to reduce runoff</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "center" }}>
                                                {cropAreaRecordItems != undefined && cropAreaRecordItems != null && cropAreaRecordItems.map((item, idx) => (
                                                    <tr key={uuid()}>
                                                        <td style={{ width: "5%" }}><button type="button"
                                                            onClick={(itemId) => handleCropRecordPopupEdit(item.id, cropAreaItem.itemId)}
                                                            className="btn btn-sm btn-edit">
                                                            <FaEdit />
                                                        </button></td>
                                                        <td style={{ width: "5%" }}>{item.yearValue}</td>
                                                        <td style={{ width: "10%" }}>{item.cropTypeText}</td>
                                                        <td style={{ width: "10%" }}>{item.cropYield}</td>
                                                        <td style={{ width: "20%" }}>{item.monthSown}</td>
                                                        <td style={{ width: "20%" }}>{item.monthsGrazedHarvested}</td>
                                                        <td style={{ width: "10%" }}>{item.cultivationMethodText}</td>
                                                        <td style={{ width: "20%", fontSize: "11px", textAlign: "left" }}>{item.mitigationsToReduceSedimentSoilRunoff}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                {cropAreaItem.nonContiguousItems != undefined && cropAreaItem.nonContiguousItems.length > 0 &&
                                    <Row sm="2">
                                        <Col>
                                        </Col>
                                        <Col>
                                            <ListGroup className="hide-child-checkbox">
                                                <ListGroupItem>
                                                    Combined Crop Area Display
                                                    <select className="form-control input-sm map-popup-input-text float-end" name="childCropAreaDisplay"
                                                        value={hideChildren.childCropAreaDisplay}
                                                        onChange={(event, cropAreaItemId) => handleHideChildrenCheck(event, cropAreaItem.itemId)}>
                                                        <option key={uuid()} value={0} >Map Only</option>
                                                        <option key={uuid()} value={1}>Map & Table</option>
                                                    </select>
                                                </ListGroupItem>
                                            </ListGroup>
                                        </Col>
                                    </Row>
                                }
                                {!hideChildren.ishideChildren &&
                                    <Row>
                                        <Col>
                                            {cropAreaItem.nonContiguousItems != undefined && cropAreaItem.nonContiguousItems.length > 0 && cropAreaItem.nonContiguousItems.map(childitem =>
                                                <CroppingChildItemView handleHideChildrenCheck={handleHideChildrenCheck} hideChildren={hideChildren} key={uuid()} handleCropRecordPopupOpen={handleCropRecordPopupOpen} handleItemEditPopup={handleItemEditPopup} handleCropRecordPopupEdit={handleCropRecordPopupEdit}
                                                    toggleItemState={toggleItemState} handleItemTogole={handleItemTogole} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle}
                                                    cropAreaItem={childitem} cropAreaRecordItems={cropping.cropAreaRecordItems.filter(x => x.cropAreaId == childitem.itemId)} handleItemHighlight={handleItemHighlight}></CroppingChildItemView>
                                            )
                                            }
                                        </Col>
                                    </Row>
                                }
                            </CardBody>
                        </Collapse>
                    </Card>
                </Col>
            </Row>
        )
    }
}
export default CropAreaItemView;